const Home = resolve => {
    require.ensure(['../components/home/Index'], () => {
        resolve(require('../components/home/Index'))
    });
};

const Restaurants = resolve => {
    require.ensure(['../components/restaurants/Index'], () => {
        resolve(require('../components/restaurants/Index'))
    });  
};

const Location = resolve => {
    require.ensure(['../components/location/Index'], () => {
        resolve(require('../components/location/Index'))
    });
};

const MyAccount = resolve => {
    require.ensure(['../components/auth/Profile'], () => {
        resolve(require('../components/auth/Profile'))
    });
};

const ViewRestaurant = resolve => {
    require.ensure(['../components/restaurant_details/Index.vue'], () => {
        resolve(require('../components/restaurant_details/Index.vue'))
    })
};

const Basket = resolve => {
    require.ensure(['../components/basket/Index.vue'], () => {
        resolve(require('../components/basket/Index.vue'))
    });
};

const Checkout = resolve => {
    require.ensure(['../components/checkout/Index.vue'], () => {
        resolve(require('../components/checkout/Index.vue'))
    });
};

const AwaitingPayment = resolve => {
    require.ensure(['../components/checkout/AwaitingPayment.vue'], () => {
        resolve(require('../components/checkout/AwaitingPayment.vue'))
    });
};

const PasswordReset = resolve => {
  require.ensure(['../components/auth/Resets.vue'], () => {
    resolve(require('../components/auth/Resets.vue'));
  });
};

const MyOrders = resolve => {
  require.ensure(['../components/orders/Index.vue'], ()=> {
      resolve(require('../components/orders/Index.vue'));
  });
};

const Privacy = resolve => {
  require.ensure(['../components/privacy/Index.vue'], ()=> {
      resolve(require('../components/privacy/Index.vue'));
  });
};

const NotFound = resolve => {
  require.ensure(['../components/not_found/Index.vue'], ()=> {
      resolve(require('../components/not_found/Index.vue'));
  });
};

const OrderDetails = resolve => {
  require.ensure(['../components/orders/Details.vue'], ()=> {
      resolve(require('../components/orders/Details.vue'));
  });
};

export default [
    {
      path: '/',
      component: Home,
      name: 'home'
    },

    {
      path: '/restaurants',
      component: Restaurants,
      name: 'restaurants'
    },

    {
      path: '/restaurants/:id',
      component: ViewRestaurant,
      name: 'view_restaurant',
      props: true
    },

  	{
  		path: '/location',
  		component: Location,
  		name: 'location'
  	},

    {
      path: '/my_account',
      component: MyAccount,
      name: 'my_account'
    },

    {
      path: '/basket',
      component: Basket,
      name: 'basket'
    },

    {
      path: '/checkout',
      component: Checkout,
      name: 'checkout'
    },

    {
      path: '/awaiting_payment',
      component: AwaitingPayment,
      name: 'awaiting_payment'
    },

    {
      path: '/password_reset',
      component: PasswordReset,
      name: 'reset',
    },

    {
      path: '/orders',
      component: MyOrders,
      name: 'orders'
    },

    {
      path: '/orders/:order_id',
      component: OrderDetails,
      name: 'view_order',
      props: true
    },

    {
      path: '/privacy',
      component: Privacy,
      name: 'privacy'
    },

    {
      path: '*',
      component: NotFound,
      name: 'not_found'
    }
];


// WEBPACK FOOTER //
// ./src/router/routes.js